import React from 'react';
import './Loader.css';

export function GridSkeleton({ count = 6, height = 320 }) {
  return (
    <div className="grid grid-3">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="skeleton" style={{ height }} />
      ))}
    </div>
  );
}

export default function Loader() {
  return (
    <div className="loader-wrap">
      <div className="loader-spin" />
    </div>
  );
}
